/**
 * Los 8 productos destacados del momento en la home (orden fijo).
 * Cambia los slugs aquí cuando quieras otro mix.
 */
export const homeFeaturedProductSlugs: readonly string[] = [
  "taza-arcana-ceramica-11",
  "taza-sello-vidrio-10",
  "taza-neon-peltre-12",
  "camiseta-shogun-tech",
  "poster-alu-luna-a3",
  "termo-ruta-500",
  "buzo-neon-ronin",
  "caja-eclipsio-premium",
] as const;
